import {Button} from "../../../basic/button.tsx";
import {Plus} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface UserActionsProps {
    totalUsers: number;
    onCreateUser: () => void;
}

export function UserActions({totalUsers, onCreateUser}: UserActionsProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="flex items-center gap-2">
            <p className="text-muted-foreground">{t('admin.users.totalUsers', {count: totalUsers})}</p>
            <Button onClick={onCreateUser}>
                <Plus className="h-4 w-4 mr-2"/>
                {t('admin.users.createUserButton')}
            </Button>
        </div>
    );
}